import React from 'react'
import Image from 'next/image'

type FiveMinutesAlarmModalProps = {
  closeModalCallback: () => void
}

const FiveMinutesAlarmModal: React.FC<FiveMinutesAlarmModalProps> = ({ closeModalCallback }) => {
  return (
    <div>
      <div className={'font-bold text-2xl'}>시험 종료 알림</div>
      <div className={'flex justify-center mt-[30.98px]'}>
        <Image src={'/exam/redTimer.png'} alt={'종료 알람'} width={64.38} height={58.87} />
      </div>
      <div className={'text-lg font-bold mt-[22.15px]'}>
        시험 종료 전 <span className={'text-errorColor'}>5분</span> 남았습니다.
      </div>
      <button
        className={'mt-5 w-[288px] h-[56px] bg-bosalpim text-white rounded-lg font-bold text-lg'}
        onClick={closeModalCallback}
      >
        확인{' '}
      </button>
    </div>
  )
}

export default FiveMinutesAlarmModal
